function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import PropTypes from 'prop-types';
import { MakeFlagIconOptionsPropType } from '../types/propTypes';
var defaultOptions = {
  useCssModules: true
};
export default (function (options) {
  var computedOptions = _objectSpread({}, defaultOptions, options);
  PropTypes.checkPropTypes(MakeFlagIconOptionsPropType(), computedOptions, 'key', 'FlagIconFactory options');
  return computedOptions;
});